module.exports = __webpack_public_path__ + "img/LS20130912_greenfire_019.6970f3f6.jpg";